import { useState, useEffect, useCallback } from 'react';

export const useTimer = (initialTime, onTimeout) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRunning, setIsRunning] = useState(true);

  const resetTimer = useCallback((newTime = initialTime) => {
    setTimeLeft(newTime);
    setIsRunning(true);
  }, [initialTime]);

  const pauseTimer = useCallback(() => {
    setIsRunning(false);
  }, []);

  useEffect(() => {
    let timer;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(t => {
          if(t - 0.1 <=0){
            return 0
          }else{
            return t-0.1
          }
        } );
      }, 100);
    }
    return () => clearInterval(timer);
  }, [isRunning, timeLeft]);

  useEffect(() => {
    if (timeLeft === 0) {
      setIsRunning(false);
      onTimeout?.();
    }
  }, [timeLeft, onTimeout]);

  return { 
    timeLeft, 
    resetTimer,
    pauseTimer,
    formattedTime: `${Math.floor(timeLeft / 60)}:${(timeLeft % 60).toString().padStart(2, '0')}`
  };
};